import EnrolmentsAdapter from './base';

export default class Credential extends EnrolmentsAdapter {
  modelNamePlural = 'credentials';
}
